module.exports = __webpack_public_path__ + "static/media/JusticeSociale_PictoCdlT.09099292.png";